import { string, shape, array } from 'prop-types'
import { graphql } from 'gatsby'

import Layout from '@/layout'
import EnhancedListProvider from '@/context/EnhancedList'
import { FILTERS, SECTIONS } from '@/constants'
import {
  buildIndustries,
  buildCountries,
  buildLanguages,
  buildTypes,
} from '@/utils/partners'
import SEO from '@/components/SEO'
import Experts from '@/components/Experts'

const Partners = ({ data: { expertCampaign, allExpert } }) => {
  const { featured, experts } = expertCampaign
  const allExperts = allExpert.nodes

  const campaignExperts = experts
    ? allExperts.filter(({ id }) => experts.includes(id))
    : allExperts

  const featuredExperts = campaignExperts.filter(({ id }) =>
    featured.includes(id)
  )

  const defaultFiltersValues = {
    services: [],
  }

  const defaultFiltersOptions = {
    [FILTERS.INDUSTRY.ID]: buildIndustries(allExperts),
    [FILTERS.COUNTRY.ID]: buildCountries(allExperts),
    [FILTERS.LANGUAGE.ID]: buildLanguages(campaignExperts),
    [FILTERS.SERVICE.ID]: buildTypes(allExperts),
  }

  const supportedFilters = [
    FILTERS.LANGUAGE.ID,
    FILTERS.SERVICE.ID,
    FILTERS.INDUSTRY.ID,
    FILTERS.COUNTRY.ID,
  ]

  return (
    <EnhancedListProvider
      items={campaignExperts}
      defaultFilters={defaultFiltersValues}
      defaultFiltersOptions={defaultFiltersOptions}
      supportedFilters={supportedFilters}
      section={SECTIONS.EXPERTS}
    >
      <Layout headerLabel="Partners">
        <Experts campaign={expertCampaign} featured={featuredExperts} />
      </Layout>
    </EnhancedListProvider>
  )
}

Partners.propTypes = {
  data: shape({
    expertCampaign: shape({
      featured: array,
      experts: array,
      path: string,
    }),
    allExpert: shape({ nodes: array }),
  }),
}

export default Partners

/* eslint-disable react/prop-types */
export const Head = ({ data: { expertCampaign } }) => {
  const { path } = expertCampaign

  return (
    <SEO
      title="Connect with Certified LiveChat Partners"
      description="Meet certified experts to implement and staff LiveChat on your website or boost your online presence!"
      path={`/partners${path || '/'}`}
    />
  )
}
/* eslint-enable react/prop-types */

export const query = graphql`
  query ($id: String!) {
    expertCampaign(id: { eq: $id }) {
      id
      featured
      experts
      description
      name
      title
    }
    allExpert(sort: { reviewsNumber: DESC }) {
      nodes {
        logo {
          ...ProductLogo
        }
        id
        name
        slug
        phone
        company
        logo2x
        country
        agents
        hourRate
        projectRate
        country
        languages
        industries
        linkedin
        facebook
        website
        description
        shortDescription
        reviewsNumber
        reviews {
          comment
          author
          creation_timestamp
          website
        }
        types
      }
    }
  }
`
